import angular from 'angular';

import RwRetailerIdComponent from './rw-retailer-id-component';

export default angular
  .module('rw-retailer-id', ['lsp-filters'])
  .component('rwRetailerId', RwRetailerIdComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-retailer-id/rw-retailer-id-module.js